import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "..";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const importEmployees = request => {
  return dispatch => {
    dispatch({ type: "IMPORT_EMPLOYEES_LOADING" });
    api
      .importEmployeesPost(request)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "ImportEmployeesErrorAlertTitle",
          "Virhe henkilöiden tuonnissa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

export const importPsa = update => {
  return dispatch => {
    dispatch({ type: "IMPORT_EMPLOYEES_LOADING" });
    api
      .importPsaPost(update)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "ImportEmployeesErrorAlertTitle",
          "Virhe henkilöiden tuonnissa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

export const exportPsa = () => {
  return dispatch => {
    dispatch({ type: "EXPORT_EMPLOYEES_LOADING" });
    api
      .exportPsaPost()
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "ExportEmployeesErrorAlertTitle",
          "Virhe henkilöiden viennissä",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

export const exportSevera = (updateExisting, personIds) => {
  return dispatch => {
    dispatch({ type: "EXPORT_EMPLOYEES_LOADING" });
    api
      .exportSeveraPost(updateExisting, personIds)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "ExportEmployeesErrorAlertTitle",
          "Virhe henkilöiden viennissä",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

export const importProcountor = (updateExisting, createNew, personIds) => {
  return dispatch => {
    dispatch({ type: "IMPORT_EMPLOYEES_LOADING" });
    api
      .importProcountorPost(updateExisting, createNew, personIds)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "ImportEmployeesErrorAlertTitle",
          "Virhe henkilöiden tuonnissa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

export const exportProcountor = (updateExisting, createNew, personIds) => {
  return dispatch => {
    dispatch({ type: "EXPORT_EMPLOYEES_LOADING" });
    api
      .exportProcountorPost(updateExisting, createNew, personIds)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "ExportEmployeesErrorAlertTitle",
          "Virhe henkilöiden viennissä",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

export const importNetvisor = (updateExisting, personIds) => {
  return dispatch => {
    dispatch({ type: "IMPORT_EMPLOYEES_LOADING" });
    api
      .importNetvisorPost(updateExisting, personIds)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "ImportEmployeesErrorAlertTitle",
          "Virhe henkilöiden tuonnissa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

export const exportNetvisor = (updateExisting, personIds) => {
  return dispatch => {
    dispatch({ type: "EXPORT_EMPLOYEES_LOADING" });
    api
      .exportNetvisorPost(updateExisting, personIds)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "ExportEmployeesErrorAlertTitle",
          "Virhe henkilöiden viennissä",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "IMPORT_EMPLOYEES_SUCCEEDED",
  payload: { importEmployees: data },
});

const operationFail = () => ({
  type: "IMPORT_EMPLOYEES_FAIL"
});
